/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var User = createReactComponent("user", "User", [["path", { "d": "M15 7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m4.5 13c-.475-9.333-14.525-9.333-15 0", "key": "svg-0" }]]);

export { User as default };
//# sourceMappingURL=User.js.map
